export default __webpack_public_path__ + "static/media/banner-bg-1.9342fee7.jpg";